module.exports = __webpack_public_path__ + "static/media/Portrait-10235.eced7ae9.jpg";